import { gql } from '@apollo/client';

export const mandantSettings = gql`
  query getMandantSettings($mandantId: ID, $registerId: ID) {
    getMandantSettings(mandantId: $mandantId, registerId: $registerId) {
      _id
      registrationEnabled
      newUserEnterMobile
      newUserEnterAddress
    }
  }
`;

export const updateMandantSettingsMut = gql`
  mutation updateMandantSettings(
    $mandantId: ID!
    $registrationEnabled: Boolean
    $newUserEnterMobile: NewUserAdditionalFieldsType
    $newUserEnterAddress: NewUserAdditionalFieldsType
  ) {
    updateMandantSettings(
      mandantId: $mandantId
      registrationEnabled: $registrationEnabled
      newUserEnterMobile: $newUserEnterMobile
      newUserEnterAddress: $newUserEnterAddress
    ) {
      _id
      registrationEnabled
    }
  }
`;
